var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgASdkAccountsCyan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#017EB4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1946_12587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9981 12C21.6249 12.0004 19.3051 12.7044 17.332 14.0231C15.3589 15.3419 13.8211 17.216 12.9131 19.4087C12.0051 21.6013 11.7676 24.0139 12.2307 26.3415C12.6938 28.6691 13.8366 30.8072 15.5147 32.4853C17.1928 34.1634 19.3309 35.3062 21.6585 35.7693C23.9861 36.2324 26.3987 35.9949 28.5913 35.0869C30.784 34.1789 32.6581 32.6411 33.9769 30.668C35.2956 28.6949 35.9996 26.3751 36 24.0019C35.9964 20.8199 34.7308 17.7693 32.4808 15.5192C30.2307 13.2692 27.1801 12.0036 23.9981 12ZM32.8666 29.4231C31.1614 27.3352 27.8318 25.9142 23.9981 25.9142C20.1598 25.9142 16.8297 27.3352 15.1265 29.425C14.1598 27.8483 13.6308 26.0424 13.5942 24.1933C13.5575 22.3442 14.0144 20.5188 14.9178 18.905C15.8212 17.2912 17.1385 15.9474 18.734 15.012C20.3294 14.0766 22.1454 13.5834 23.9949 13.5832C25.8443 13.583 27.6604 14.0758 29.2561 15.0109C30.8517 15.9459 32.1693 17.2895 33.073 18.9031C33.9768 20.5167 34.434 22.342 34.3978 24.1911C34.3615 26.0402 33.8329 27.8462 32.8666 29.4231L32.8666 29.4231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9025 24.1184C27.0231 23.6178 28.3363 21.493 27.8357 19.3725C27.3351 17.2519 25.2103 15.9387 23.0898 16.4393C20.9693 16.9399 19.656 19.0647 20.1566 21.1852C20.6572 23.3057 22.782 24.6189 24.9025 24.1184Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1946_12587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgASdkAccountsCyan);
export default __webpack_public_path__ + "static/media/a_sdkAccounts_cyan.7b771d2832639b8a921931346151e64b.svg";
export { ForwardRef as ReactComponent };